import {
  CreateSerialNumbersResponse,
  EditUssRequestBody,
  EditUssResponse,
  GetSerialNumbersResponse,
  UssHistoryResponse,
  UssRequestBody,
} from 'api/Responses/SetSerialNumberResponses';
import axiosInstance from 'services/APIService';

// v2 is the only endpoint path for USS
const ENDPOINT_PATH_V2 = `/v2/uss`;

/*
 * Loads a set from the database into a draft bucket
 */
export const getUniqueSetSerialNumbersForSet = async (displayCode: string): Promise<GetSerialNumbersResponse> => {
  const response = await axiosInstance.get<GetSerialNumbersResponse>(`${ENDPOINT_PATH_V2}/${displayCode}/`);
  return response.data;
};

/*
 * Add serial number
 */
export const addSerialNumber = async (ussRequestBody: UssRequestBody): Promise<CreateSerialNumbersResponse> => {
  const response = await axiosInstance.post<CreateSerialNumbersResponse>(`${ENDPOINT_PATH_V2}/create_uss/`, {
    ...ussRequestBody,
  });
  return response.data;
};

/*
 * Add serial number
 */
export const editSerialNumber = async (
  setUssId: string,
  editUssRequestBody: EditUssRequestBody,
): Promise<EditUssResponse> => {
  const response = await axiosInstance.put<EditUssResponse>(`${ENDPOINT_PATH_V2}/${setUssId}/update_uss/`, {
    ...editUssRequestBody,
  });
  return response.data;
};

/*
 * Activity history for one serial number
 */
export const getSerialNumberHistory = async (
  setUssId: string,
  range?: { occurredFrom: string; occurredTo: string },
): Promise<UssHistoryResponse> => {
  const response = await axiosInstance.get<UssHistoryResponse>(`${ENDPOINT_PATH_V2}/${setUssId}/history/`, {
    params: range && { occurred_from: range.occurredFrom, occurred_to: range.occurredTo },
  });
  return response.data;
};
